import {
  Grid3x3,
  Bath,
  Home,
  Building2,
  Sun,
  Gem,
  ClipboardCheck,
  ArrowUpRight,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES, IMAGES } from "../../data/content";

const ICONS = { Grid3x3, Bath, Home, Building2, Sun, Gem, ClipboardCheck };

export const Services = () => (
  <section id="leistungen" data-testid="services-section" className="py-20 md:py-28 bg-[#F5F2ED]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="text-[#B5651D] text-xs uppercase tracking-[0.25em] font-semibold mb-4">
          Unsere Leistungen
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2933] max-w-2xl">
          Meisterhandwerk für jeden Raum
        </h2>
        <p className="mt-4 text-[#4B5563] max-w-2xl text-base md:text-lg">
          Vom privaten Badezimmer bis zum großen Gewerbeobjekt — wir verlegen
          Fliesen, Platten, Klinker, Mosaik und Naturstein in höchster Qualität.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.07}>
              <div
                data-testid={`service-card-${i}`}
                className="group bg-white border border-[#E5E1D8] p-8 h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#F5F2ED] text-[#B5651D] transition-all duration-300 group-hover:bg-[#B5651D] group-hover:text-white">
                    <Icon size={22} />
                  </div>
                  <ArrowUpRight
                    size={18}
                    className="text-[#C9B79C] opacity-0 transition-all duration-300 group-hover:opacity-100"
                  />
                </div>
                <h3 className="font-heading font-semibold text-xl text-[#1F2933] mt-6">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          );
        })}
        <Reveal delay={7 * 0.07}>
          <div className="relative h-full min-h-[220px] overflow-hidden group">
            <img
              src={IMAGES.marble}
              alt="Edle Natursteinstruktur aus Marmor"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#1F2933]/50 flex items-end p-8">
              <p className="font-heading font-semibold text-white text-lg leading-snug">
                Naturstein, Marmor & Mosaik — Materialien mit Charakter.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
